<template>
    <v-flex xs12 md10 offset-md1>
        <v-toolbar color="blue darken-1" dark>
            <v-toolbar-title>Rename Group</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
            <v-card-title>
                <v-text-field
                        v-model="renameGroupText"
                        label="New name for this Group"
                        single-line
                        hide-details
                ></v-text-field>
                <v-btn color="default" @click="renameThisGroup">Rename</v-btn>
            </v-card-title>
        </v-card>
        <v-dialog v-model="renameDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Rename This Group?</v-card-title>
                <v-card-text>Please confirm that you want to rename this group.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click.native="proceed">Yes, rename</v-btn>
                    <v-btn color="green darken-1" flat @click.native="renameDialog = false">No, cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        name: "GroupRename",
        props: ['group'],
        data() {
            return {
                renameDialog: false,
                renameGroupText: ''
            }
        },
        computed: {
            groupId: function () {
                return this.group
            }
        },
        methods: {
            ...mapActions(['renameGroup']),
            renameThisGroup: function () {
                if (this.renameGroupText !== '') {
                    this.renameDialog = true
                }
            },
            proceed: function () {
                this.renameGroup([this.groupId, this.renameGroupText])
                this.renameDialog = false
                this.renameGroupText = ''
            }
        }
    }
</script>

<style scoped>

</style>
